export default __webpack_public_path__ + "static/schools_banner-6e05f6653a5bc9d7b415a19e84aebccd.png";